import { RestService } from "@sinossi/mates-react-library"
import {
	MicrojobberRequest,
	MicrojobberWrapper,
} from "models/microjobber"
import { NewUserRequest, PaginatedResponse, UserRequest, Users } from "models"

export class UserServices {
	static getMicrojobbers = (request: MicrojobberRequest, callback: any, catchCallback: any) => {
		RestService
			.post<PaginatedResponse<MicrojobberWrapper>>(`/api/microjobs/users/filter`, request)
			.then(callback)
			.catch(catchCallback)
	}

	static usersData = (request: UserRequest, callback: any, catchCallback: any) => {
		RestService
			.post<PaginatedResponse<Users>>("/api/account/filter", request)
			.then(callback)
			.catch(catchCallback)
	}

	static createUser = (request: NewUserRequest, callback: any, catchCallback: any) => {
		RestService
			.post("/api/account/create", request)
			.then(callback)
			.catch(catchCallback)
	}

	static toggleSuperAdmin = (accountId: string, isSuperAdmin: boolean, callback: any, catchCallback: any) => {
		RestService
			.put(`/api/account/${accountId}/super-admin?isSuperAdmin=${isSuperAdmin}`, {})
			.then(callback)
			.catch(catchCallback)
	}
}
